<script setup lang="ts">
import type { IFaqItem } from '~/components/entity/faq/items/types'
import { LucideAlertCircle, LucideMessageCircleQuestion } from 'lucide-vue-next'

const props = defineProps<{ item: IFaqItem }>()
</script>

<template>
  <Accordion type="single" collapsible class="Accordion">
    <AccordionItem :value="String(props.item.id)" class="AccordionItem">
      <AccordionTrigger class="AccordionTrigger">
        <div class="flex flex-1 items-center gap-3">
          <div class="hidden rounded-md bg-blue-600 p-2">
            <LucideAlertCircle class="h-5 w-5 text-white" />
          </div>
          <div class="block rounded-md bg-gray-100 p-2">
            <LucideMessageCircleQuestion class="h-5 w-5 text-gray-900" />
          </div>
          <div class="flex-1">
            <Heading tag="h3" class="h5">
              <div v-hydrated-html="props.item.title" class="hit-title" />
            </Heading>
          </div>
        </div>
      </AccordionTrigger>
      <AccordionContent class="pb-4 text-base">
        <TransitionBlock>
          <div class="ml-3 px-16">
            <Content>
              <div v-hydrated-html="props.item.description" class="hit-title" />
            </Content>
          </div>
        </TransitionBlock>
      </AccordionContent>
    </AccordionItem>
  </Accordion>
</template>
